import React from 'react';
import PropTypes from 'prop-types';
function RadioInputGroup(_ref) {
  var options = _ref.options,
    handleInputChange = _ref.handleInputChange,
    selected = _ref.selected,
    name = _ref.name,
    className = _ref.className,
    style = _ref.style,
    idKey = _ref.idKey;
  if (style === 'checkbox') {
    return /*#__PURE__*/React.createElement("div", {
      className: "form-group ".concat(className)
    }, options.map(function (option) {
      return /*#__PURE__*/React.createElement("label", {
        className: "custom-checkbox-container",
        htmlFor: "".concat(idKey ? "".concat(idKey, "-") : '').concat(option.value),
        key: option.value
      }, /*#__PURE__*/React.createElement("input", {
        type: "checkbox",
        id: "".concat(idKey ? "".concat(idKey, "-") : '').concat(option.value),
        value: option.value,
        name: name,
        checked: selected === option.value,
        onClick: function onClick() {
          return handleInputChange(option);
        }
      }), /*#__PURE__*/React.createElement("span", {
        className: "checkmark"
      }), /*#__PURE__*/React.createElement("span", {
        className: "label body-text-2"
      }, option.label));
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "form-group g-row--always ".concat(className)
  }, options.map(function (option) {
    return /*#__PURE__*/React.createElement("div", {
      className: "option me-4",
      key: option.value
    }, /*#__PURE__*/React.createElement("input", {
      type: "radio",
      id: "".concat(idKey ? "".concat(idKey, "-") : '').concat(option.value),
      value: option.value,
      name: name,
      checked: selected === option.value,
      onChange: function onChange() {
        return handleInputChange(option);
      }
    }), /*#__PURE__*/React.createElement("label", {
      htmlFor: "".concat(idKey ? "".concat(idKey, "-") : '').concat(option.value)
    }, option.label));
  }));
}
RadioInputGroup.propTypes = {
  options: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  handleInputChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  selected: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  className: PropTypes.string,
  style: PropTypes.string,
  idKey: PropTypes.string
};
RadioInputGroup.defaultProps = {
  selected: null,
  className: '',
  style: 'radio',
  idKey: null
};
export default RadioInputGroup;